import React from 'react'
import './Alert.css'

const Alert = (props) => {
  if (props.type === 'success') {
    return (
      <div className='alert' onClick={props.onClick}>
        <div className='alert__content alert__content--success'>
          <div className='alert__content__icon'>
            <i className='material-icons'>check_circle</i>
          </div>
          <div className='alert__content__text'>
            {props.children}
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className='alert' onClick={props.onClick}>
        <div className='alert__content alert__content--error'>
          <div className='alert__content__icon'>
            <i className='material-icons'>error</i>
          </div>
          <div className='alert__content__text'>
            {props.children}
          </div>
        </div>
      </div>
    )
  }
}

export default Alert
